<div class="contact-us">
  <p class="contact-us-text">{{ 'pro.contactUs.text' | translate }}</p>
  <button class="contact-us-button" (click)="openContactLink()">
    {{ 'pro.contactUs.button' | translate }}
  </button>
</div>
